module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAARCAYAAAA/mJfHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgBzZOxTgJBEIb/mV0rMdFSKkuv9gGks7Uiucp7B57AJ/ARvEoSOvQFpLf2otVV1kRISAg7w9wRKKBijwS+Yncnk3yZ/JMlGJOi32FwB3syh+RXSVquaz8t+hmze0UEZ+JKu/KNzJF7EsXw/Lb7iIb4+iTcz34GUdNVBAmjVpLmtYxBTlQfEInFlP1/v41rmZJ+QvCMKLQNoncmf8k4IMeVySJcKFNqW7tuLCPv7xjaI6e97Z7HnhDk1wL/QNBRVTWSmeBPQ7V52umc+DZV0MYB8AoaEumLRfCFKFbZ2Xcc169pMcgIeoNIbKCylXTzJTEMR+4D5SeyAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/workOrderReview/wallet.png
// module id = IhDg
// module chunks = 0